import { Grid2 as Grid, Box, Typography } from "@mui/material";

import ImageLinkCard from "components/UI/Cards/ImageLinkCard";
import { useAuth } from "hooks/useAuth";

import { TRAINING_CARD_TYPES, TRAINING_CARDS } from "./data/trainingCards.data";

const TrainingHome = () => {
  const { permissions } = useAuth();
  const roleType = permissions.role_type;

  const visibleCards = TRAINING_CARDS.filter(
    ({ roles }) => !roles || roles.includes(roleType),
  );

  const evalCards = visibleCards.filter(
    ({ type }) => type === TRAINING_CARD_TYPES.EVALUATION,
  );
  const refCards = visibleCards.filter(
    ({ type }) => type === TRAINING_CARD_TYPES.REFERENCE,
  );

  return (
    <Box sx={{ px: 3, m: 5 }}>
      <Typography variant="h1" sx={{ mt: 5, mb: 3 }}>
        Training Center
      </Typography>
      {evalCards.length > 0 && (
        <>
          <Typography variant="h3" sx={{ mt: 5, mb: 3 }}>
            Evaluation Flows
          </Typography>
          <Grid
            container
            spacing={5}
            justifyItems={"center"}
            alignItems="center"
          >
            {evalCards.map((card) => (
              <Grid size={{ sm: 6, md: 3 }} key={card.slug}>
                <ImageLinkCard
                  icon={<card.icon sx={{ fontSize: 64, color: card.color }} />}
                  color={card.color}
                  title={card.title}
                  description={card.description}
                  slug={card.slug}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}

      <Typography variant="h3" sx={{ mt: 5, mb: 3 }}>
        References
      </Typography>
      <Grid container spacing={5} justifyItems={"center"} alignItems="center">
        {refCards.map((card) => (
          <Grid size={{ sm: 6, md: 3 }} key={card.slug}>
            <ImageLinkCard
              icon={<card.icon sx={{ fontSize: 64, color: card.color }} />}
              color={card.color}
              title={card.title}
              description={card.description}
              slug={card.slug}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TrainingHome;
